<template>
  <div>
    <v-snackbar v-model="showSnackBar" color="#FC4B4B" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #ffffff">
            {{ msg }}
          </span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #ffffff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap pb-7>
      <v-flex
        xs12
        text-center
        style="background-color:#F8F8F8 ;font-family:sofiaPro;font-size:11px"
      >
        <v-btn :ripple="false" text style="text-transform:none"
          ><span style="color:#000;border-bottom:2px solid #3460E1"
            >Primary Details
          </span></v-btn
        >
        <v-btn :ripple="false" text style="text-transform:none">
          <span style="color:#ACACAC;">
            Services & Working Hours
          </span>
        </v-btn>
        <v-btn :ripple="false" text style="text-transform:none">
          <span style="color:#ACACAC">Bank Details </span></v-btn
        >
        <v-btn :ripple="false" text style="text-transform:none">
          <span style="color:#ACACAC"> Documents </span>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-container>
      <v-form ref="form">
        <v-layout wrap justify-center>
          <v-flex xs12 lg6>
            <v-card>
              <v-layout wrap justify-center>
                <v-flex xs12 pt-6>
                  <span class="sofiaPro">Primary Details</span>
                </v-flex>
                <v-flex xs3 pb-4>
                  <v-progress-linear
                    height="2"
                    value="100"
                    color="#D8D6D6DE"
                  ></v-progress-linear>
                </v-flex>
              </v-layout>
              <v-layout wrap justify-center>
                <v-flex>
                  <v-card v-if="coverImage == null">
                    <v-img
                      width="100%"
                      height="250px"
                      :src="require('../../assets/Images/c2.png')"
                      class="align-end"
                    >
                      <v-layout wrap pa-7>
                        <v-flex xs3 text-center>
                          <v-card elevation="1">
                            <v-img
                              height="140px"
                              src="../../assets/Images/c2.png"
                              v-if="profileImage == null"
                            >
                              <Propic
                                @stepper="profilewinStepper"
                                :height="'811'"
                                :width="'811'"
                                :heading="'Upload Profile Picture'"
                                :componentType="'coverImage'"
                              />
                            </v-img>
                            <v-img height="140px" :src="pic2" v-else>
                              <Propic
                                @stepper="profilewinStepper"
                                :height="'811'"
                                :width="'811'"
                                :heading="'Upload Profile Picture'"
                                :componentType="'coverImage'"
                              />
                            </v-img>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-img>
                    <v-card-text>
                      <CoverImageComp
                        @stepper="winStepper"
                        :height="'2118'"
                        :width="'8001'"
                        :heading="'Upload Cover Image'"
                        :componentType="'coverImage'"
                      />
                    </v-card-text>
                  </v-card>
                  <v-card v-else>
                    <v-img
                      width="100%"
                      height="250px"
                      :src="pic"
                      class="align-end"
                    >
                      <v-layout wrap pa-7>
                        <v-flex xs3 text-center>
                          <v-card elevation="1">
                            <v-img
                              height="140px"
                              src="../../assets/Images/c2.png"
                              v-if="profileImage == null"
                            >
                              <Propic
                                @stepper="profilewinStepper"
                                :height="'811'"
                                :width="'811'"
                                :heading="'Upload Profile Picture'"
                                :componentType="'coverImage'"
                              />
                            </v-img>
                            <v-img height="140px" :src="pic2" v-else>
                              <Propic
                                @stepper="profilewinStepper"
                                :height="'811'"
                                :width="'811'"
                                :heading="'Upload Profile Picture'"
                                :componentType="'coverImage'"
                              />
                            </v-img>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-img>
                    <v-card-text>
                      <CoverImageComp
                        @stepper="winStepper"
                        :height="'2118'"
                        :width="'8001'"
                        :heading="'Upload Cover Image'"
                        :componentType="'coverImage'"
                      />
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
              <v-layout wrap justify-center>
                <v-flex xs12 px-3 pt-3 text-left>
                  <span class="sofiaPro">Shop Name</span>
                  <v-text-field
                    dense
                    outlined
                    class="rounded"
                    :rules="[rules.required]"
                    v-model="shopName"
                    label="Shop  Name"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 px-3 text-left>
                  <span class="sofiaPro">Description</span>
                  <v-text-field
                    class="rounded"
                    dense
                    outlined
                    :rules="[rules.required]"
                    v-model="description"
                    label="Description"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 px-3 text-left>
                  <span class="sofiaPro">Location</span>
                  <v-text-field
                    class="rounded"
                    dense
                    outlined
                    :rules="[rules.required]"
                    v-model="Location"
                    label="Address"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 px-3 text-left>
                  <span class="sofiaPro">City</span>
                  <v-text-field
                    disabled
                    class="rounded"
                    dense
                    outlined
                    :rules="[rules.required]"
                    v-model="cityy"
                    label="City"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 px-3 text-left>
                  <span class="sofiaPro">Pincode</span>
                  <v-text-field
                    class="rounded"
                    dense
                    outlined
                    :rules="[pincodeRules.required, pincodeRules.min]"
                    v-model="pinn"
                    label="Pincode"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex xs12 pb-3 text-left px-3>
                  <span class="sofiaPro">Select location</span>
                </v-flex>

                <v-flex xs12 px-3>
                  <div id="map44"></div>
                </v-flex>
                <v-flex xs12 px-3 text-left pt-3>
                  <span class="sofiaPro">Email</span>
                  <v-text-field
                    class="rounded"
                    dense
                    outlined
                    :rules="[rules.email]"
                    v-model="email"
                    label="Email"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 px-3 text-left>
                  <span class="sofiaPro">Whatsapp Number</span>
                  <v-text-field
                    class="rounded"
                    v-model="whatsapp"
                    dense
                    type="number"
                    maxlength="10"
                    outlined
                    :rules="[rulesd.required, rulesd.min]"
                    label="Whatsapp Number"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 px-3 text-left>
                  <span class="sofiaPro">Contact Person</span>
                  <v-text-field
                    class="rounded"
                    dense
                    outlined
                    :rules="[rules.required]"
                    v-model="conatctperson"
                    label="Contact Person"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 px-3 text-left>
                  <span class="sofiaPro">Instagram Url</span>
                  <v-text-field
                    class="rounded"
                    dense
                    outlined
                    v-model="instagram"
                    label="Instagram Url"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 px-3 text-left>
                  <span class="sofiaPro">Facebook URL </span>
                  <v-text-field
                    class="rounded"
                    dense
                    outlined
                    v-model="facebook"
                    label="Facebook URL"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex xs12 text-center py-7 px-3>
                  <v-btn
                    width="100%"
                    dark
                    block
                    color="#E31E24"
                    @click="profileUpdate"
                  >
                    next</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-form>
    </v-container>
  </div>
</template>
<script src="https://maps.googleapis.com/maps/api/js?libraries=places&key=AIzaSyCaccNxbzwR9tMvkppT7bT7zNKjChc_yAw&libraries=visualization,drawing"></script>
<script>
var map = [];
var state = "";
var city = "";
var pin = "";
var addrs = "";
import CoverImageComp from "./singleImage";
import Propic from "./profileImage";
import axios from "axios";
export default {
  components: {
    CoverImageComp,
    Propic,
  },
  data() {
    return {
      conatctperson: null,
      instagram: null,
      facebook: null,
      Location: null,
      pic: null,
      pic2: null,
      cityy: "",
      locCity: null,
      state: null,
      pinn: "",
      shopName: "",
      email: "",
      whatsapp: "",
      contactPerson: "",
      lat: 0,
      lon: 0,
      sample: null,
      tab: null,
      changedlat: null,
      changedlon: null,
      sp: [],
      timeout: 3000,
      video: [],
      videoData: new FormData(),
      levelData: new FormData(),
      // level1: new formData(),
      urlgallery: [],
      url7: [],
      marker: [],
      msg: "",
      maps: null,
      showSnackBar: false,
      showCoverImage: "",
      coverImage: null,
      profileImage: null,
      coverData: new FormData(),
      appLoading: false,
      gallery: new FormData(),
      description: "",
      name: "",
      phone: "",
      email: "",
      address: "",
      apiary: "",
      videoURL: "",
      displayName: "",
      keeperDescription: "",
      pincodeRules: {
        required: (value) => !!value || "Required",
        min: (value) => value.length == 6 || "Invalid Pincode",
      },
      rulesd: {
        required: (value) => !!value || "Required",
        min: (value) => value.length == 10 || "Invalid Phone",
      },
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 10 || "Max 10 digits",
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      imageFiles: [],
      sellerId: [],
      imageArray: [],
      flag: true,
      currentLatt: null,
      currentLonn: null,
      l: "",
      n: "",
    };
  },
  computed: {
    profileData() {
      if (this.sellerData) {
        return this.sellerData;
      } else return {};
    },
  },
  mounted() {
    // this.getUser();
    this.getMap();
    this.getGeoLoaction();
    // this.getLocation();

    this.marker = new google.maps.Marker({
      position: { lat: this.lat, lng: this.lon },
      map: this.maps,
      title: "",
    });
  },

  methods: {
    displayLocation(latitude, longitude) {
      this.marker = new google.maps.Marker({
        position: { lat: latitude, lng: longitude },
        center: { lat: latitude, lng: longitude },
        map: this.maps,
        title: "!",
      });
      var hole;
      var vm = this;
      var geocoder;
      geocoder = new google.maps.Geocoder();
      var latlng = new google.maps.LatLng(latitude, longitude);

      const jm = geocoder.geocode({ latLng: latlng }, function(
        results,
        status
      ) {
        if (status == google.maps.GeocoderStatus.OK) {
          if (results[0]) {
            var add = results[0].formatted_address;
            var value = add.split(",");

            var count = value.length;
            addrs = results;
            // console.log("Addressss", addrs);
            //  country=value[count-1];
            pin = value[count - 2];
            city = value[count - 3];
            var str = pin;
            var matches = str.match(/(\d+)/);
            if (matches) {
              pin = matches[0];
            }
          } else {
            console.log("Address not found");
          }
          vm.cityy = city;
          vm.pinn = pin;
        } else {
          console.log("geocoder failed");
        }
      });
      this.cityy = hole;
    },
    //// abow testing lines for geolocation
    getGeoLoaction() {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          this.gettingLocation = false;
          this.location = pos;
          this.lat = this.location.coords.latitude;
          this.lon = this.location.coords.longitude;
          this.displayLocation(this.lat, this.lon);
        },
        (err) => {
          this.gettingLocation = false;
          this.errorStr = err.message;
        }
      );
    },

    profilewinStepper(window_data) {
      if (window_data.type == "coverImage") {
        this.profileImage = window_data.selectedFiles;
        this.pic2 = window_data.img;
      }
    },

    winStepper(window_data) {
      if (window_data.type == "coverImage") {
        this.coverImage = window_data.selectedFiles;
        this.pic = window_data.pic;
      }
    },
    // galleryStepper(window_data) {
    //   if (window_data.type == "image") {
    //     this.imageArray = window_data.imageArray;
    //     this.imageFiles.push(window_data.selectedFiles);
    //   } else if (window_data.type == "imageRemoval") {
    //     this.imageFiles.splice(window_data.removalItem, 1);
    //     this.imageArray = window_data.imageArray;
    //   } else if (window_data.type == "imageDeletion") {
    //     if (window_data.response.status) this.getUser();
    //   }
    //   if (window_data.getData) {
    //     this.getUser();
    //   }
    // },
    getMap() {
      var vm = this;
      var geocoder;
      geocoder = new google.maps.Geocoder();
      const gmap = new google.maps.Map(document.getElementById("map44"), {
        center: { lat: 20.5937, lng: 78.9629 },
        zoom: 5,
      });
      this.maps = gmap;
      google.maps.event.addListener(this.maps, "click", (e) => {
        geocoder.geocode(
          {
            latLng: e.latLng,
          },
          function(results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
              if (results[0]) {
                map = results[0].address_components;
                for (var i = 0; i < map.length; i++) {
                  if (map[i].types.includes("administrative_area_level_1")) {
                    vm.state = map[i].long_name;
                    // console.log("state is", vm.state);
                  }
                  if (map[i].types.includes("locality")) {
                    vm.city = map[i].long_name;
                    vm.cityy = vm.city;
                    // console.log("city is", vm.city);
                  }
                  if (map[i].types.includes("postal_code")) {
                    vm.pin = map[i].long_name;
                    vm.pinn = vm.pin;
                    // console.log("pincode is", vm.pin);
                  }
                }
              } else {
                alert("No results found");
              }
            } else {
              alert("Geocoder failed due to: " + status);
            }
          }
        );
        this.cityy = vm.city;
        this.state = vm.state;
        this.pinn = vm.pin;
        this.mark(e);
      });
    },
    mark(event) {
      this.lat = null;
      this.lon = null;
      this.marker.setMap(null);
      this.lat = event.latLng.lat();
      this.lon = event.latLng.lng();

      this.marker = new google.maps.Marker({
        position: { lat: this.lat, lng: this.lon },
        map: this.maps,
        title: "",
      });
    },

    profileUpdate() {
      if (this.lat > 0 && this.lon > 0) {
        if (this.$refs.form.validate()) {
          this.levelData.append("photo", this.profileImage);
          this.levelData.append("coverPhoto", this.coverImage);
          this.levelData.append("shopName", this.shopName);
          this.levelData.append("description", this.description);
          this.levelData.append("place", this.Location);
          //  this.levelData.append("place", this.address);
          this.levelData.append("city", this.cityy);
          this.levelData.append("pincode", this.pinn);
          this.levelData.append("lat", this.lat);
          this.levelData.append("lon", this.lon);
          this.levelData.append("contactPerson", this.conatctperson);
          this.levelData.append("email", this.email);
          this.levelData.append("whatsapp", this.whatsapp);
          this.levelData.append("facebook", this.facebook);
          this.levelData.append("instagram", this.instagram);
          axios({
            method: "post",
            url: "seller/profile/level1",
            headers: {
              token: localStorage.getItem("token"),
            },
            data: this.levelData,
          }).then((response) => {
            if (response.data.status) {
              this.showSnackBar = true;
              this.msg = response.data.msg;

              this.$emit("stepper", {
                // level:1,
                level: response.data.level,
              });
            } else {
              this.showSnackBar = true;
              this.msg = response.data.msg;
            }
            this.levelData = new FormData();
            this.appLoading = false;
          });
        }
      } else {
        this.msg = "Please Turn-On your location.";
        this.showSnackBar = true;
      }
    },
    //new line of codes

    getUser() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/view/" + this.$route.query.seller,
        headers: {
          token: localStorage.getItem("token"),
        },
        params: {
          id: this.$route.query.seller,
        },
      }).then((response) => {
        if (response.data.status) {
          this.lat = response.data.data.sellerid.location[1];
          this.lon = response.data.data.sellerid.location[0];

          this.getMap();
          this.marker = new google.maps.Marker({
            position: { lat: this.lat, lng: this.lon },
            map: this.maps,
          });
        } else {
          this.appLoading = false;
        }
      });
    },
  },
};
</script>

<style>
.center >>> input {
  text-align: center;
  font-family: robotobold;
}
.v-text-field >>> label {
  font-family: sofialight;
  color: red;
}
.v-text-field--outlined {
  border-radius: 5px;
  font-family: sofialight;
  font-size: 18px;
}

#map44 {
  height: 400px;
  width: 100%;
  margin: 0px;
  padding: 0px;
}
</style>
